import { Controller } from "@hotwired/stimulus"

// Taken from:
// https://github.com/stimulus-components/stimulus-components/blob/77cfef949b41b2119e44b4714581532b9c7451f4/components/rails-nested-form/src/index.ts
// converted from ts to js
// and extended with customizable record placeholder value (https://github.com/stimulus-components/stimulus-components/pull/160)
export default class RailsNestedForm extends Controller {
  static targets = ["target", "template"]
  static values = {
    wrapperSelector: {
      type: String,
      default: ".nested-form-wrapper",
    },
    newRecordPlaceholder: {
      type: String,
      default: "NEW_RECORD",
    },
  }

  counter = 0

  add(e) {
    e.preventDefault()

    const content = this.templateTarget.innerHTML.replaceAll(this.newRecordPlaceholderValue, new Date().getTime().toString() + this.counter++)
    this.targetTarget.insertAdjacentHTML("beforebegin", content)

    const event = new CustomEvent("rails-nested-form:add", { bubbles: true })
    this.element.dispatchEvent(event)
  }

  remove(e) {
    e.preventDefault()

    const wrapper = e.target.closest(this.wrapperSelectorValue)

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
    } else {
      wrapper.style.display = "none"

      const input = wrapper.querySelector("input[name*='_destroy']")
      input.value = "1"
    }

    const event = new CustomEvent("rails-nested-form:remove", { bubbles: true })
    this.element.dispatchEvent(event)
  }
}
